import React, { useState } from 'react';
import { getProviderManagerSSOSettings } from "../../../../services/staffingService"; // Adjust path accordingly
import { Mail } from 'lucide-react';

const SSO = ({ providerCompanyId }) => {
    const [copied, setCopied] = useState(false); // Track copy action

    // Function to handle link generation and redirection
    const handleRedirect = async () => {
        try {
            const response = await getProviderManagerSSOSettings(providerCompanyId); // Fetch the SSO link
            window.location.href = response.link; // Redirect the user to the generated link
        } catch (error) {
            console.error('Error generating SSO link:', error);
        }
    };

    // Function to handle link generation and copying to clipboard
    const handleCopy = async () => {
        try {
            const response = await getProviderManagerSSOSettings(providerCompanyId); // Fetch the SSO link
            await navigator.clipboard.writeText(response.data.link); // Copy link to clipboard
            setCopied(true); // Update the copy status to true
        } catch (error) {
            console.error('Error copying SSO link:', error);
        }
    };

    return (
  
        <div className="flex items-start bg-white rounded-lg shadow-sm p-4 mb-4">

            {/* <h3>SSO Set Up for IT Admin</h3>
            <button onClick={handleRedirect}>Go</button>  
            <button onClick={handleCopy}>{copied ? 'Link Copied!' : 'Copy'}</button>  */}

            <Mail className="text-green-500 mr-5 mt-1" style={{ fontSize: "20px" }} />
            
                          <div>
                            <h6 className="mb-1 text-sm font-semibold text-brand-blue-dark">
                              Inegrate SSO 
                            </h6>
                            <p className="mb-2 text-sm text-gray-600">
                              Share the link with your IT Admin to integrate SSO.
                            </p>

                              {" "}
                              <button onClick={handleCopy} className="px-2 py-1 rounded-lg bg-brand-blue-dark text-white text-sm font-medium hover:opacity-90 transition-opacity">
                              {copied ? 'Link Copied!' : 'Copy'}
                              </button>{" "}
                          </div>
        </div>

    );
};

export default SSO;
